import { NgModule } from '@angular/core';
import { NavigationEnd, NavigationStart, Router, RouterModule, Routes } from '@angular/router';
import { MainpageComponent } from '@layout/mainpage/mainpage.component';
import { AboutModule } from '@modules/about/about.module';
import { ContactModule } from '@modules/contact/contact.module';
import { HomeModule } from '@modules/home/home.module';
import { AboutUsComponent } from '@shared/cms-pages/about-us/about-us.component';
import { FaqComponent } from '@shared/cms-pages/faq/faq.component';
import { PrivacyPolicyComponent } from '@shared/cms-pages/privacy-policy/privacy-policy.component';
import { TermsAndConditionsComponent } from '@shared/cms-pages/terms-and-conditions/terms-and-conditions.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/home',
    pathMatch: 'full'
  },
  {
    path: '',
    component: MainpageComponent,
    children: [
      {
        path: 'home',
        loadChildren: () => import('@modules/home/home.module').then((m) => m.HomeModule)
      },
      {
        path: 'about',
        loadChildren: () => import('@modules/about/about.module').then((m) => m.AboutModule)
      },
      {
        path: 'contact',
        loadChildren: () => import('@modules/contact/contact.module').then((m) => m.ContactModule)
      },
      {
        path: 'customer',
        loadChildren: () => import('@modules/myProfile/myProfile.module').then((m) => m.myProfileModule)
      },
      {
        path: 'flight',
        loadChildren: () => import('@modules/flight/flight.module').then((m) => m.FlightResultModule)
      },
      {
        path: 'hotel',
        loadChildren: () => import('@modules/hotel/hotel.module').then((m) => m.HotelResultModule)
      },
      { path: 'page/about-us', component: AboutUsComponent },
      { path: 'page/terms-and-conditions', component: TermsAndConditionsComponent },
      { path: 'page/privacy-policy', component: PrivacyPolicyComponent },
      { path: 'page/faq', component: FaqComponent },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true, scrollPositionRestoration: 'top', anchorScrolling: 'enabled', scrollOffset: [0, 0] })],
  exports: [RouterModule]
})
export class AppRoutingModule {
  private isFirstNavigation = true;

  constructor(private router: Router) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (this.isFirstNavigation) {
          this.isFirstNavigation = false;
        } else {
          // Reload the page on every navigation except the initial load
          // window.location.reload();
        }
      } else if (event instanceof NavigationStart) {
        // Scroll to the top after a short delay (e.g., 100ms) to allow potential content loading
        setTimeout(() => {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }, 100); // 100 milliseconds delay before scrolling to the top
      }
    });
  }
}
